import { Box } from '@mui/material';
import React from 'react';
import FundDetailsTabsButton from './FundDetailsTabsButton';
import { useTranslation } from 'react-i18next';

export interface IFundDetailsTabsProps{
    onTabClick: (index: number) => void;
    selectedTab: number;
}
const FundDetailsTabs: React.FC<IFundDetailsTabsProps> = ({ onTabClick, selectedTab }) => {
    const { t } = useTranslation();
    
    const content = [t('LibraryOfFundsTabOverview'), t('LibraryOfFundsTabFundTeam'),t('LibraryOfFundsTabTrackRecord'),t('LibraryOfFundsTabDataRoom')];

    return <Box display={"flex"} width={"100%"}  gap={"26px"}>
        {content.map((c, i) => <FundDetailsTabsButton key={`tab-${c}`} name={c} isSelected={selectedTab === i} onClick={() => onTabClick(i)} />)}
        {/* <FundDetailsTabsButton name={t('LibraryOfFundsTabOverview')} isSelected onClick={() => {}} />
        <FundDetailsTabsButton name={t('LibraryOfFundsTabFundTeam')} onClick={() => {}} />
        <FundDetailsTabsButton name={t('LibraryOfFundsTabTrackRecord')} onClick={() => {}} />
        <FundDetailsTabsButton name={} onClick={() => {}} /> */}
    </Box>;
}

export default FundDetailsTabs;